export default __webpack_public_path__ + "static/media/BADGE_ATTENTION_YELLOW.bd7bec04.svg";